import { Component, AfterViewInit, Renderer2, OnDestroy, OnInit, HostListener } from '@angular/core';
import { MenuService } from '../../service/app.menu.service';
//import { PrimeNGConfig } from 'primeng/api';
import { AppComponent } from '../../../app.component';
import { StorageService } from '../../../../app/shared/service/storage/storage.service';
import { AuthService } from '../../../../app/shared/service/auth/auth.service';
import { PortalProfileService } from '../../../../app/shared/service/portal-profile/portal-profile.service';
import { Router } from '@angular/router';
import { CommonService } from '../../../../app/shared/service/common/common.service'
import { AppRoutes } from "../../../../app/shared/lib/api-constant";
import { SubSink } from "subsink";
import { UserControlService } from '../../service/userControl/user-control.service';
import { tap } from 'rxjs';
import { UserSettings } from '../../lib/types/UserSettingsTypes';
@Component({
    selector: 'app-main',
    templateUrl: './app.main.component.html',
    styleUrls: ['./app.main.component.scss'],
    standalone :false
})
export class AppMainComponent implements AfterViewInit, OnDestroy, OnInit {

    rotateMenuButton: boolean;

    topbarMenuActive: boolean;

    overlayMenuActive: boolean;

    staticMenuDesktopInactive: boolean;

    staticMenuMobileActive: boolean;

    menuClick: boolean;

    topbarItemClick: boolean;

    activeTopbarItem: any;

    documentClickListener: () => void;

    configActive: boolean;

    configClick: boolean;

    rightPanelActive: boolean;

    rightPanelClick: boolean;

    showMenu: boolean = false;

    menuHoverActive = false;

    searchClick = false;

    checked: boolean;

    firstName: string;

    lastName: string;

    companyTitle: string;
    isOnly3PLUsers: boolean = false;
    search = false;
    nonRiskFeature: any = [];
    LspUser: any = [];
    companyList: any;
    keyRef: string = 'bdpReferenceNumber';
    currentKeyRef: string = 'bdpReferenceNumber';
    displayKeyRefDialog: boolean = false;
    hasUserScrolledToBottom: boolean = true;
    private subscription = new SubSink();
    displayBasic: boolean;
    hasNavGpt: boolean = false;
    showNavGpt: boolean = false;
    @HostListener('scroll', ['$event'])
    onScroll(event: any) {
        // visible height + pixel scrolled >= total height 
        if (event.target.offsetHeight + event.target.scrollTop >= event.target.scrollHeight) {
            this.hasUserScrolledToBottom = false;
        }
    }
    constructor(
        public renderer: Renderer2,
        private menuService: MenuService,
        //private primengConfig: PrimeNGConfig,
        public app: AppComponent,
        public storageService: StorageService,
        public portalProfileService: PortalProfileService,
        public authService: AuthService,
        public router: Router,
        private commonService: CommonService,
        private userControlService: UserControlService,
        private appService: UserControlService,
    ) {
        this.userControlService.$userFeatures.subscribe((featureList: any) => {
            if (featureList.data) {
                console.log("called from app main")
                this.userControlService.updateUserSettings(featureList.data);
            }})
        this.showMenu = true;
    }
    ngOnInit() {
       
    }
    ngAfterViewInit() {
        // hides the horizontal submenus or top menu if outside is clicked
        this.documentClickListener = this.renderer.listen('body', 'click', (event) => {
            if (!this.topbarItemClick) {
                this.activeTopbarItem = null;
                this.topbarMenuActive = false;
            }

            if (!this.menuClick && this.isHorizontal()) {
                this.menuService.reset();
            }

            if (this.configActive && !this.configClick) {
                this.configActive = false;
            }

            if (!this.rightPanelClick) {
                this.rightPanelActive = false;
            }

            if (!this.menuClick) {
                if (this.overlayMenuActive) {
                    this.overlayMenuActive = false;
                }
                if (this.staticMenuMobileActive) {
                    this.staticMenuMobileActive = false;
                }

                this.menuHoverActive = false;
                this.unblockBodyScroll();
            }

            if (!this.searchClick) {
                this.search = false;
            }

            this.searchClick = false;
            this.configClick = false;
            this.topbarItemClick = false;
            this.menuClick = false;
            this.rightPanelClick = false;
        });
       // Inactivity check
        this.authService.checkInactivityStatus();
        // Auth0 session check
        this.authService.checkAuthenticationStatus();

    }

    onMenuButtonClick(event: any) {
        this.rotateMenuButton = !this.rotateMenuButton;
        this.topbarMenuActive = false;
        this.menuClick = true;

        if (this.app.menuMode === 'overlay' && !this.isMobile()) {
            this.overlayMenuActive = !this.overlayMenuActive;
        }

        if (this.isDesktop()) {
            this.staticMenuDesktopInactive = !this.staticMenuDesktopInactive;
        } else {
            this.staticMenuMobileActive = !this.staticMenuMobileActive;
            if (this.staticMenuMobileActive) {
                this.blockBodyScroll();
            } else {
                this.unblockBodyScroll();
            }
        }

        event.preventDefault();
    }

    onMenuClick() {
        this.menuClick = true;
    }

    onTopbarItemClick(event: any, item: any) {
        this.topbarItemClick = true;
        console.log(item);
        if (this.activeTopbarItem === item) {
            this.activeTopbarItem = null;
        } else {
            this.activeTopbarItem = item;
        }

        if (item.className === 'search-item topbar-item') {
            this.search = !this.search;
            this.searchClick = !this.searchClick;
        }

        event.preventDefault();
    }
    onTopbarSubItemClick(event: Event, navigateTo: string = '') {
        event.preventDefault();
        switch (navigateTo) {
            case AppRoutes.Auth.LOGOUT: {
                this.authService.logout();
                break;
            }
            case AppRoutes.User.RELEASE_NOTES: {
                this.commonService.navigateRoute({
                    route: AppRoutes.User.RELEASE_NOTES,
                    type: 'User',
                });
                break;
            }
            case AppRoutes.User.STATUS_CONFIGURATION: {
                this.commonService.navigateRoute({
                    route: AppRoutes.User.STATUS_CONFIGURATION,
                    type: 'User',
                });
                break;
            }
            case AppRoutes.User.PORT_CONFIGURATION: {
                this.commonService.navigateRoute({
                    route: AppRoutes.User.PORT_CONFIGURATION,
                    type: 'User',
                });
                break;
            }
        }
    }


    onRTLChange(event: any) {
        this.app.isRTL = event.checked;
    }

    onRippleChange(event: any) {
        this.app.ripple = event.checked;
        //this.primengConfig.ripple = event.checked;
    }

    onConfigClick(event: any) {
        this.configClick = true;
    }

    // onRightPanelButtonClick(event) {
    //     this.rightPanelClick = true;
    //     this.rightPanelActive = !this.rightPanelActive;
    //     event.preventDefault();
    // }

    // onRightPanelClick() {
    //     this.rightPanelClick = true;
    // }

    isTablet() {
        const width = window.innerWidth;
        return width <= 1024 && width > 640;
    }

    isDesktop() {
        return window.innerWidth > 1024;
    }

    isMobile() {
        return window.innerWidth <= 640;
    }

    isOverlay() {
        return this.app.menuMode === 'overlay';
    }

    isStatic() {
        return this.app.menuMode === 'static';
    }

    isHorizontal() {
        return this.app.menuMode === 'horizontal';
    }

    blockBodyScroll(): void {
        if (document.body.classList) {
            document.body.classList.add('blocked-scroll');
        } else {
            document.body.className += ' blocked-scroll';
        }
    }

    unblockBodyScroll(): void {
        if (document.body.classList) {
            document.body.classList.remove('blocked-scroll');
        } else {
            document.body.className = document.body.className.replace(new RegExp('(^|\\b)' +
                'blocked-scroll'.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
        }
    }



    ngOnDestroy() {
        if (this.documentClickListener) {
            this.documentClickListener();
        }
        this.subscription.unsubscribe();
    }
}
